/**
 * Application configuration from environment variables
 * All environment variables must be prefixed with VITE_ to be exposed to the client
 */

export const config = {
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
    version: import.meta.env.VITE_API_VERSION || 'v1',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000', 10),
  },

  // Application Configuration
  app: {
    name: import.meta.env.VITE_APP_NAME || 'PesaJet Pay',
    environment: import.meta.env.VITE_APP_ENVIRONMENT || 'development',
  },

  // Feature Flags
  features: {
    analytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    debugMode: import.meta.env.VITE_ENABLE_DEBUG_MODE === 'true',
  },

  // Refresh Intervals (milliseconds)
  intervals: {
    transactionRefresh: parseInt(import.meta.env.VITE_TRANSACTION_REFRESH_INTERVAL || '30000', 10),
    dashboardRefresh: parseInt(import.meta.env.VITE_DASHBOARD_REFRESH_INTERVAL || '60000', 10),
  },

  // Pagination
  pagination: {
    defaultPageSize: parseInt(import.meta.env.VITE_DEFAULT_PAGE_SIZE || '20', 10),
    maxPageSize: parseInt(import.meta.env.VITE_MAX_PAGE_SIZE || '100', 10),
  },

  // Documentation
  docs: {
    url: import.meta.env.VITE_DOCS_URL || 'http://localhost:3000/api/docs',
  },

  // Analytics (optional)
  analytics: {
    id: import.meta.env.VITE_ANALYTICS_ID || '',
  },

  // Security
  security: {
    httpsOnly: import.meta.env.VITE_ENABLE_HTTPS_ONLY === 'true',
  },
} as const;

// Helper function to check if running in development mode
export const isDevelopment = () => config.app.environment === 'development';

// Helper function to check if running in production mode
export const isProduction = () => config.app.environment === 'production';
